import type { BoxProps } from '@mantine/core';
import { Group, useMantineTheme } from '@mantine/core';

import { getSx } from '../../../../../../shared/utils/sx';
import { useActiveTab } from './hooks/useActiveTab';
import { Tab } from './tab';
import { TabsActive } from './tabsActive';

interface Tab {
  id: string;
  label?: string;
  children?: React.ReactNode;
}

interface TabsProps {
  containerProps?: BoxProps;
  activeTabId?: string;
  onTabChange?: (tabId: string) => void;
  tabs: Tab[];
}

export function Tabs({
  containerProps = {},
  tabs,
  activeTabId,
  onTabChange,
}: TabsProps) {
  const { sx: containerSx = [], ...restContainerProps } = containerProps;
  const { width, left, height, initial } = useActiveTab(activeTabId ?? '');
  const theme = useMantineTheme();

  return (
    <Group
      bg={theme.white}
      sx={[
        {
          width: 'fit-content',
          borderRadius: 100,
          position: 'relative',
          zIndex: 1,
        },
        ...getSx(containerSx),
      ]}
      p="01"
      spacing={0}
      {...restContainerProps}
    >
      {tabs.map(tab => (
        <Tab
          key={tab.id}
          label={tab.label}
          tabId={tab.id}
          onClick={onTabChange}
          isActive={activeTabId === tab.id}
        />
      ))}
      <TabsActive width={width} left={left} height={height} initial={initial} />
    </Group>
  );
}
